/* Read Shopify's actual cart. No client-side discounts or automatic additions. */
(() => {
  'use strict';
  if (window.MochiCart) return;
  const root = window.Shopify?.routes?.root || '/';
  let state, timer, inFlight = false, again = false;
  const read = node => JSON.parse(node.querySelector('[data-mz-cart-state]').textContent);
  const canCheckout = s => s.itemCount > 0 && (s.count >= 6 || s.standalone);
  function apply(s) {
    state = s;
    const allowed = canCheckout(s);
    document.querySelectorAll('button[name="checkout"], .cart__checkout-button, .mzoo-cart-sticky__checkout').forEach(button => {
      // Only remove the lock imposed by this component. Other app locks stay intact.
      if (!allowed && !button.disabled) { button.dataset.mzMinimumLock = 'true'; button.disabled = true; }
      else if (allowed && button.dataset.mzMinimumLock) { button.disabled = false; delete button.dataset.mzMinimumLock; }
    });
    document.querySelectorAll('.cart__dynamic-checkout-buttons, .dynamic-checkout__content').forEach(el => {
      if (!allowed && !el.hidden) { el.dataset.mzMinimumLock = 'true'; el.hidden = true; }
      else if (allowed && el.dataset.mzMinimumLock) { el.hidden = false; delete el.dataset.mzMinimumLock; }
    });
    let note = document.getElementById('minimo-mochimals-aviso');
    if (!allowed && s.itemCount > 0) {
      const target = document.querySelector('.cart__ctas, .cart-drawer__footer');
      if (!note && target) { note = document.createElement('p'); note.id = 'minimo-mochimals-aviso'; note.setAttribute('role', 'status'); target.append(note); }
      if (note) note.textContent = `Te faltan ${Math.max(0, 6 - s.count)} Mochimals para completar tu manada de 6. ${document.body.classList.contains('mz-halloween') ? 'Salem y el castillo también se pueden comprar solos.' : ''}`;
    } else note?.remove();
    document.dispatchEvent(new CustomEvent('mz:cart-state', {detail:s}));
  }
  async function refresh() {
    clearTimeout(timer);
    if (inFlight) { again = true; return; }
    inFlight = true;
    try {
      const response = await fetch(root + 'cart?section_id=mz-cart-state', {cache:'no-store', headers:{'Accept':'text/html'}});
      if (!response.ok) throw new Error('cart-state');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      apply(read(html));
    } catch (error) {
      // Never invent cart quantities or savings when a refresh fails.
      document.dispatchEvent(new CustomEvent('mz:cart-state-error'));
    } finally {
      inFlight = false;
      if (again) { again = false; schedule(); }
    }
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(refresh, 180); }
  window.MochiCart = {refresh, get state() { return state; }};
  try { apply(read(document)); } catch (error) { schedule(); }
  ['cart:refresh','cart:updated','cart:change','cqag:added','cqag:changed','cqag:added-all'].forEach(name => document.addEventListener(name, schedule));
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, schedule);
  addEventListener('pageshow', event => { if (event.persisted) schedule(); });
  document.addEventListener('visibilitychange', () => { if (!document.hidden) schedule(); });
  document.addEventListener('shopify:section:load', () => { if (state) apply(state); schedule(); });
  // Native cart sections replace their buttons asynchronously after a cart event.
  const cartNode = document.querySelector('cart-drawer, #main-cart-footer');
  if (cartNode) new MutationObserver(records => {
    if (records.some(r => [...r.addedNodes].some(n => n.nodeType === 1 && (n.matches?.('[name="checkout"]') || n.querySelector?.('[name="checkout"]'))))) schedule();
  }).observe(cartNode, {childList:true, subtree:true});
})();

